const API_BASE_URL = ('https://trustedoptions.net/trustedoptions-api');

export type SubscribePayload = {
  email: string;
  message?: string;
  options?: Record<string, unknown>;
};

export async function submitSubscribeRequest(payload: SubscribePayload) {
  const response = await fetch(`${API_BASE_URL}/subscriptions/unsubscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...payload,
      is_unsubscribe: false,
    }),
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.message || 'Unable to submit your request. Please try again.');
  }

  return data;
}
